/*
 *
 * DialogPortal
 *
 * DialogPortal provides a first-class way to render
 * Dialog into a DOM node that exists outside the DOM
 * hierarchy of the parent component.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

class DialogPortal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

DialogPortal.propTypes = {
  children: PropTypes.any,
};

export default DialogPortal;
